import { PreHoverContentProps } from './hover-card.types';

import styles from './hover-card.module.css';

const PreHoverContent = ({
  backgroundColor = 'transparent',
  children,
  backgroundImage,
  backgroundSize = 'cover',
}: PreHoverContentProps) => {
  return (
    <div
      className={`height-100-percent width-100-percent ${styles.preHoverContent} ${backgroundImage ? `bg-image-${backgroundSize}` : ''}`}
      data-component="PreHoverContent"
      style={{
        ...(backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}),
        ...(backgroundColor && { '--pre-hover-content-background-color': backgroundColor }),
      }}
    >
      <>{children}</>
    </div>
  );
};

export default PreHoverContent;
